/**
 * @see https://developer.mozilla.org/en-US/docs/Web/Events/scroll
 */
function activeMenuOption(elementsClass, menuElementId) {
  let lastKnownScrollPosition = 0
  let ticking = false
  const $menuElem = $(`#${menuElementId}`)
  const $elements = $(`.${elementsClass}`)
  const $window = $(window)

  $window
    .off(`scroll.${menuElementId}menuOption`)
    .on(`scroll.${menuElementId}menuOption`, () => {
      lastKnownScrollPosition = $window.scrollTop()
      if (!ticking) {
        window.requestAnimationFrame(function () {
          $elements.each(function () {
            const top = $(this).offset().top - 145
            const bottom = top + $(this).outerHeight()

            if (lastKnownScrollPosition >= top && lastKnownScrollPosition <= bottom) {
              $menuElem.find('a').removeClass('active')
              $elements.find('button').removeClass('active')

              $(this).find('button').addClass('active')
              $menuElem
                .find('a[data-detailid="' + $(this).attr('id') + '"]') // cspell:disable-line
                .addClass('active')
            }
          })

          ticking = false
        })

        ticking = true
      }
    })
}

export default activeMenuOption
